import { ReactComponent as SvgScore } from '../../../../images/svg/icon-93-nps-score.svg'
import { ReactComponent as SvgTrust } from '../../../../images/svg/icon-trust-radius.svg'
import { ReactComponent as Svgusers} from '../../../../images/svg/icon-million-users.svg'
import styles from './styles.module.css'

const Card = (props) => {
  const { icon, excellence, minor } = props
  return (
    <div className={styles.card_wrapper}>
      <div className={styles.card}>
        <div className={styles.card_content}>
          {icon}
          <span className={styles.card_excellence}>{excellence}</span>
          <span className={styles.card_minor}>{minor}</span>
        </div>
      </div>
    </div>
  )
}

const Award = () => {
  return (
    <>
      <p className={styles.desc}>Over 200,000 businesses trust us.</p>
      <div className={styles.awards}>
        <Card icon={<SvgScore />} excellence="93" minor="Industry's highest NPS Score" />
        <Card icon={<SvgTrust />} excellence="Best Of" minor="2023" />
        <Card icon={<SvgTrust />} excellence="Best Software" minor="2022" />
        <Card icon={<SvgTrust />} excellence="Best Value for Price" minor="WINTER 2023" />
        <Card icon={<Svgusers />} excellence="30+" minor="Million users" />
      </div>
    </>
  )
}

export default Award
